module.exports = __webpack_public_path__ + "images/custom-service-icon-bab1f0ef0c77b94b1e4b0d7dc2f2a0cd.svg";